import { render } from "./no-access.vue?vue&type=template&id=31b81130&lang=pug"
import script from "./no-access.vue?vue&type=script&lang=js"
export * from "./no-access.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__